import RegisterPage from 'feature/login-flow/register/register-page';

export default RegisterPage;
